import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ValAddThreeDropDownData } from './valaddthree-drop-down-model';

export class ValAddThreeDropDownDataResponseModel extends GlobalResponseObject{
    data?: ValAddThreeDropDownData[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //ValAddThreeDropDownData[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: ValAddThreeDropDownData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
